module.exports = {
  PARTNER_CODE: {
    CRB: 'CRB',
    CURRENCY_CLOUD: 'CURRENCY_CLOUD',
    CURRENCY_CLOUD_GBI: 'CURRENCY_CLOUD_GBI',
    EQUIFAX: 'EQUIFAX',
    DOWJONES: 'DOWJONES',
    BERBIX: 'BERBIX',
    FEDERAL_BANK: 'FEDERAL_BANK',
    FLINKS: 'FLINKS',
    CURRENCY_CLOUD_SPARK_US: 'CURRENCY_CLOUD_SPARK_US'
  }
};
